/**
 * Created by Tiger on 02/03/2022.
 */

import React from 'react';
import {Menu} from 'antd';
import i18n from 'i18next';

export default (props) => {
  return (<Menu >
    <Menu.Item key={ 'edit' } style={ { height: 30 } } onClick={ (e) => props?.onEdit(e) }>
      <span>{ i18n.t('menu_edit') }</span>
    </Menu.Item>
    <Menu.Divider/>
    <Menu.Item key={ 'delete' } onClick={ (e) => props?.onDelete(e) }>
      <span>{ i18n.t('menu_delete') }</span>
    </Menu.Item>
  </Menu>);
};
